export default "__VITE_ASSET__DY8MFgnf__"